var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu" }, [
    _c("nav", { staticClass: "menu-items" }, [
      _c(
        "ul",
        _vm._l(_vm.data, function(item, index) {
          return _c(
            "item",
            _vm._b(
              {
                key: index,
                on: { clickItem: _vm.clickItem, close: _vm.close }
              },
              "item",
              { item: item, open: _vm.open, activeItem: _vm.activeItem },
              false
            )
          )
        }),
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mobile-menu" }, [
      _c(
        "div",
        {
          staticClass: "menu-btn",
          class: { active: _vm.mobile },
          on: { click: _vm.toggleMobile }
        },
        [
          _c("div", { staticClass: "bar" }),
          _vm._v(" "),
          _c("div", { staticClass: "bar" }),
          _vm._v(" "),
          _c("div", { staticClass: "bar" })
        ]
      ),
      _vm._v(" "),
      _vm.mobile
        ? _c("div", { staticClass: "backdrop" }, [
            _c("div", { staticClass: "inner-wrapper" }, [
              _c(
                "ul",
                { staticClass: "mobile-items" },
                _vm._l(_vm.data, function(item, index) {
                  return _c(
                    "item",
                    _vm._b(
                      {
                        key: index,
                        on: { clickItem: _vm.clickItem, close: _vm.close }
                      },
                      "item",
                      {
                        item: item,
                        open: _vm.open,
                        activeItem: _vm.activeItem
                      },
                      false
                    )
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "bottom_bar" },
                _vm._l(_vm.bottom_bar_data, function(item, index) {
                  return _c(
                    "item",
                    _vm._b(
                      {
                        key: index,
                        on: { clickItem: _vm.clickItem, close: _vm.close }
                      },
                      "item",
                      {
                        item: item,
                        open: _vm.open,
                        activeItem: _vm.activeItem
                      },
                      false
                    )
                  )
                }),
                1
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }